exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".perfect{background-color:#8bc34a;color:#000;font-size:1.5em}.good{color:#8bc34a}.bad{color:#f44336}.worst{background-color:#f44336;color:#000;font-size:1.5em}.shout{padding:10px;border-radius:10px;margin:20px}.bright{color:#000;background-color:#ff0}.help p{margin:5px 0;font-size:1.4em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c0a1378","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 25
// module chunks = 0